import { Megaphone } from 'lucide-react';
import { useTranslation } from '@dukanti/shared';
import type { TranslationKey } from '@dukanti/shared';
import { Button } from '@/components/ui/button';

export interface PromotionalAdsEmptyStateProps {
  readonly onCreate: () => void;
}

export function PromotionalAdsEmptyState({ onCreate }: PromotionalAdsEmptyStateProps) {
  const { t } = useTranslation();

  return (
    <div
      data-testid="promotional-ads-empty-state"
      className="border-border bg-card shadow-admin-card mx-auto max-w-lg rounded-lg border p-8 text-center"
    >
      <div className="bg-zaatar-wash text-zaatar-deep mx-auto mb-4 flex size-14 items-center justify-center rounded-full">
        <Megaphone className="size-7" strokeWidth={1.75} aria-hidden />
      </div>
      <h2 className="font-display text-foreground text-xl font-semibold">
        {t('admin.promotionalAds.empty.title' as TranslationKey)}
      </h2>
      <p className="text-muted-foreground mx-auto mt-2 max-w-sm text-sm">
        {t('admin.promotionalAds.empty.subtitle' as TranslationKey)}
      </p>
      <Button type="button" className="mt-5" onClick={onCreate}>
        {t('admin.promotionalAds.addNew' as TranslationKey)}
      </Button>
    </div>
  );
}
